import { AnimatedSpriteWrap } from "common/pixi/animatedSprite";
import * as cancel from "common/promises/canceler";
import { Sheets } from "common/sheets";
import { MAXIMUM_HEIGHT, MAXIMUM_WIDTH } from "first-animation/screen";
import * as PIXI from "pixi.js";
export class BButton {
    constructor(pixiContext, sheets) {
        this.idleAnimation = null;
        this.pixiContext = pixiContext;
        this.onDown = this.onDown.bind(this);
        this.state = new State();
        const textures = Sheets.animationTextures(sheets, "버튼 B");
        this.textures = textures;
        const sprite = new AnimatedSpriteWrap(pixiContext, textures);
        sprite.anchor.set(0.5, 0.5);
        this.sprite = sprite;
        this.sprite.visible = false;
        this.sprite.interactive = true;
        this.sprite.buttonMode = true;
        this.sprite.hitArea = new PIXI.Rectangle(750 / 2 - MAXIMUM_WIDTH / 2, 2000 / 2 - MAXIMUM_HEIGHT / 2, 300 / 2, 300 / 2);
        this.sprite.on("mousedown", this.onDown);
        this.sprite.on("touchstart", this.onDown);
    }
    dispose() {
        var _a;
        (_a = this.idleAnimation) === null || _a === void 0 ? void 0 : _a.canceler.cancel();
    }
    async onDown() {
        if (this.state.state !== "idle") {
            return;
        }
        if (this.callback) {
            this.callback();
        }
        this.state.state = "clicked";
        this.sprite.texture = this.textures[1];
        await this.pixiContext.delay(10);
        this.sprite.texture = this.textures[0];
        this.state.state = "idle";
    }
    setCallbak(callback) {
        this.callback = callback;
    }
    cancelIdle() {
        var _a;
        (_a = this.idleAnimation) === null || _a === void 0 ? void 0 : _a.canceler.cancel();
        this.idleAnimation = null;
    }
    idleAnimate() {
        if (this.idleAnimation != null) {
            return;
        }
        this.idleAnimation = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                this.sprite.texture = this.textures[1];
                await this.pixiContext.delay(100);
                canceler.check();
                this.sprite.texture = this.textures[0];
                await this.pixiContext.delay(100);
            }
        });
    }
}
export const imageNames = [
    encodeURIComponent("버튼 B-1.png"),
    encodeURIComponent("버튼 B-2.png"),
];
class State {
    constructor() {
        this.state = "idle";
    }
}
//# sourceMappingURL=bButton.js.map